// extracted by mini-css-extract-plugin
export default {"mypage_subsc_address":"address_mypage_subsc_address__qSUm9"};